import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenstreetmapComponent } from './simple-icons-openstreetmap.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenstreetmapComponent ],
    exports:      [ SimpleIconsOpenstreetmapComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenstreetmapModule {}
